import {
  Component, Inject, ViewEncapsulation} from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser'
import { BASE_URL, API_VERSION } from '../shared/base.url';
import { LoopBackConfig } from '../shared/sdk/lb.config';
import { TransferState } from '../../modules/transfer-state/transfer-state';
import { ArticleUtils } from '../../../common/utils/articleutils';
import {Observable} from "rxjs";
import {CostGuideUtils} from "../../../common/utils/costguideutils";
import {HeroAnimationService} from "../shared/animations/hero-animation.service";
import {ReplaySubject} from "rxjs/ReplaySubject";

@Component({
  templateUrl: './home.component.html',
  styleUrls: [ './home.component.scss' ],
  selector: 'homeComponent',
  encapsulation: ViewEncapsulation.None,
/*  animations: [ routeAnimation ],
  host: {
    '[@routeAnimation]': 'true',
    '(@routeAnimation.start)': 'animStart($event)',
    '(@routeAnimation.done)': 'animEnd($event)',
    '[style.display]': "'block'",
    '[style.position]': "'absolute'",
    '[style.left]' : "'0'",
    '[style.right]' : "'0'"
  },*/
})
export class HomeComponent {

  public featuredArticle: Observable<object>;
  public personalFinanceArticlesInHome: Array<object> = [];
  public economyArticlesInHome: Array<object> = [];
  public businessArticlesInHome: Array<object> = [];
  public realEstateArticlesInHome: Array<object> = [];
  public insuranceCostGuides: Array<object> = [];
  public homeImprovementCostGuides: Array<object> = [];
  public previousBlocks: Array<object> = [];
  protected previousBlocksReplaySubject = new ReplaySubject();
  protected previousBlocksOffset: number = 3;

  protected articlesAlreadyVisualized: Array<string> = []; // This articles will be ignored in the infinite scroll

  constructor(@Inject(DOCUMENT) protected  document: any,
              protected articleUtils: ArticleUtils,
              protected cache: TransferState,
              protected heroAnimationService: HeroAnimationService,
              protected costGuideUtils: CostGuideUtils) {

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    this.renderHomeArticles();
    this.renderCostGuides();

    //render a new block and clear infinite scroll:
    this.previousBlocksOffset = 0;
    this.previousBlocks = [];
    this.previousBlocksReplaySubject.complete();
    this.previousBlocksReplaySubject = new ReplaySubject();

    this.previousBlocksReplaySubject.subscribe((offset: number) => {

      let blockObject = {
        articles: null
      };

      // inject the list of visualized articles
      this.articleUtils.loadPreviousArticles(offset, 3, this.articlesAlreadyVisualized)
        .subscribe((articles: Array<object>) => {

          let cache = this.cache;

          if(articles != null && articles.length > 0) {

            articles.forEach(function(element){
              cache.set(element['url'], element);
            });

            blockObject.articles = articles;
            this.previousBlocks.push(blockObject);
          }
        })
    });
  }

  protected renderHomeArticles(): void {

    let cache = this.cache;

    let featuredArticleCache = cache.get('featuredArticle');

    if(featuredArticleCache != null) {

      this.featuredArticle = Observable.of(featuredArticleCache);

      this.personalFinanceArticlesInHome = cache.get('personalFinanceArticlesInHome');
      this.economyArticlesInHome = cache.get('economyArticlesInHome');
      this.businessArticlesInHome = cache.get('businessArticlesInHome');
      this.realEstateArticlesInHome = cache.get('realEstateArticlesInHome');

      this.articlesAlreadyVisualized = cache.get('articlesAlreadyVisualized');

    } else {

      this.articleUtils.loadLatestFeaturedArticle().subscribe((articleData: Array<object>) => {

        this.featuredArticle = Observable.of(articleData[0]);
        cache.set(articleData[0]['url'], articleData[0]);
        cache.set('featuredArticle', articleData[0]);
        this.articlesAlreadyVisualized.push(articleData[0]['id']);
        cache.set('articlesAlreadyVisualized', this.articlesAlreadyVisualized);

        this.articleUtils.loadSectionArticles('personal-finance', 4, []).subscribe((articles: Array<object>) => {

          this.personalFinanceArticlesInHome = articles.filter((element) => {return element['id'] !== articleData[0]['id'];}).slice(0,3);
          cache.set('personalFinanceArticlesInHome', this.personalFinanceArticlesInHome);

          articles.forEach((element) => {
            cache.set(element['url'], element);
            this.articlesAlreadyVisualized.push(element['id']);
            cache.set('articlesAlreadyVisualized', this.articlesAlreadyVisualized);
          });

          cache.set('personalFinanceArticles', articles);
        });

        this.articleUtils.loadSectionArticles('economy', 4, []).subscribe((articles: Array<object>) => {
          this.economyArticlesInHome = articles.filter((element) => { return element['id'] !== articleData[0]['id'];}).slice(0,3);
          cache.set('economyArticlesInHome', this.economyArticlesInHome);

          articles.forEach((element) => {
            cache.set(element['url'], element);
            this.articlesAlreadyVisualized.push(element['id']);
            cache.set('articlesAlreadyVisualized', this.articlesAlreadyVisualized);
          });

          cache.set('economyArticles', articles);
        });

        this.articleUtils.loadSectionArticles('business', 4, []).subscribe((articles: Array<object>) => {
          this.businessArticlesInHome = articles.filter((element) => { return element['id'] !== articleData[0]['id'];}).slice(0,3);
          cache.set('businessArticlesInHome', this.businessArticlesInHome);

          articles.forEach((element) => {
            cache.set(element['url'], element);
            this.articlesAlreadyVisualized.push(element['id']);
            cache.set('articlesAlreadyVisualized', this.articlesAlreadyVisualized);
          });

          cache.set('businessArticles', articles);
        });

        this.articleUtils.loadSectionArticles('real-estate', 4, []).subscribe((articles: Array<object>) => {
          this.realEstateArticlesInHome = articles.filter((element) => { return element['id'] !== articleData[0]['id'];}).slice(0,3);
          cache.set('realEstateArticlesInHome', this.realEstateArticlesInHome);

          articles.forEach((element) => {
            cache.set(element['url'], element);
            this.articlesAlreadyVisualized.push(element['id']);
            cache.set('articlesAlreadyVisualized', this.articlesAlreadyVisualized);
          });

          cache.set('realEstateArticles', articles);
        });

      });
    }
  }

  protected animStart(event) {
    console.log('home:animStart');
    this.heroAnimationService.registerStartAnimationEvent(event);
  }

  protected animEnd(event) {
    console.log('home:animEnd');
  }

  protected renderCostGuides() {

    var _that = this;

    let homeImprovementCostGuidesCache = _that.cache.get('homeImprovementCostGuide');
    if(homeImprovementCostGuidesCache != null) {
      this.homeImprovementCostGuides = homeImprovementCostGuidesCache;
    } else {

      // At the moment, we are hardcoding four home-improvement cost guides in home
      ['/costs/pool-all-install-build',
        '/costs/security-video-surveillance-install',
        '/costs/water-heating-electric-install',
        '/costs/roofing-all-install-replace'].forEach(function(url, index){
        _that.costGuideUtils.loadCostGuide(url).subscribe((costGuide: object) => {
          _that.homeImprovementCostGuides[index] = costGuide;
          _that.cache.set(costGuide['url'], costGuide);
          if(_that.homeImprovementCostGuides.length == 4) {
            _that.cache.set('homeImprovementCostGuide', _that.homeImprovementCostGuides);
          }
        });
      });
    }

    let insuranceCostGuidesCache = _that.cache.get('insuranceCostGuide');
    if(insuranceCostGuidesCache != null) {
      this.insuranceCostGuides = insuranceCostGuidesCache;
    } else {
      this.costGuideUtils.loadCostGuideByVertical(2, 4).subscribe((costGuides: Array<object>) => {
        this.insuranceCostGuides = costGuides;
        costGuides.forEach(function(element){
          _that.cache.set(element['url'], element);
        });
        _that.cache.set('insuranceCostGuide', costGuides);
      });
    }
  }

  public renderMoreContent() {
    this.previousBlocksOffset += 3;
    this.previousBlocksReplaySubject.next(this.previousBlocksOffset);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts